import {
    SliderTrack as AriaSliderTrack,
    SliderTrackProps as AriaSliderTrackProps,
    SliderTrackRenderProps as AriaSliderTrackRenderProps,
} from 'react-aria-components';

import { type ReactNode } from 'react';

import { cx } from '@/utils/cx';

import sliderRecipe, { SliderRecipeProps } from '@/components/slider/slider.styles';

type SliderTrackProps = {
    className?: string;
    trackClassName?: string;
    indicatorClassName?: string;
    children: (d: AriaSliderTrackRenderProps) => ReactNode;
} & AriaSliderTrackProps &
    SliderRecipeProps;

const SliderTrack = ({
    className,
    trackClassName,
    indicatorClassName,
    children,
    ...rest
}: SliderTrackProps) => {
    const [variantProps, localProps] = sliderRecipe.splitVariantProps(rest);
    const recipeClassNames = sliderRecipe(variantProps);
    return (
        <AriaSliderTrack
            {...localProps}
            className={cx('group', recipeClassNames.control, className)}>
            {(renderProps: AriaSliderTrackRenderProps) => (
                // if children isn't a function, your sort of SOL with renderProps
                // the default implementation passes a funciton and renders
                // an indicator and a thumb for each state value
                <div className={cx(recipeClassNames.track, trackClassName)}>
                    {typeof children === 'function' ? children(renderProps) : children}
                </div>
            )}
        </AriaSliderTrack>
    );
};

export { SliderTrack, SliderTrack as default };
export type { SliderTrackProps };
